import { render, staticRenderFns } from "./SettingsSpec.vue?vue&type=template&id=3776aec6"
import script from "./SettingsSpec.vue?vue&type=script&lang=js"
export * from "./SettingsSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports